// elements
const header = document.querySelector(".o-header");
const megamenu = document.querySelector(".m-mega-menu");
const burger = document.querySelector(".a-burger");

// mobile/desktop detection
const mql = window.matchMedia("(min-width: 1280px)");
const mqlHandler = (mql) => {
  document.body.classList.toggle("--mobile", !mql.matches);
  document.body.classList.toggle("--desktop", mql.matches);
  const opens = document.querySelectorAll(".--open");
  if (opens.length > 0)
    for (const open of opens) open.classList.remove("--open");
};
mql.addEventListener("change", mqlHandler);
mqlHandler(mql);
const isMobile = document.body.classList.contains("--mobile");
const isDesktop = document.body.classList.contains("--desktop");

// fix realisations
// const linkRealisations = megamenu.querySelector( 'a.realisations' )
// if( linkRealisations ) {
//   linkRealisations.parentElement.classList.add( '--has-submenu' )
// }

// burger handler
burger.addEventListener("click", (e) => {
  if (isMobile) {
    header.classList.toggle("--open");
  }
});

// megamenu click event delegation for desktop
megamenu.addEventListener("click", (e) => {
  if (isDesktop) {
    if (e.target.matches(".menu-close")) {
      const opens = document.querySelectorAll(".--open");
      if (opens.length > 0)
        for (const open of opens) open.classList.remove("--open");
    }

    const parentItem = e.target.closest(".--has-submenu");
    if (parentItem) {
      e.preventDefault();
      const link = parentItem.querySelector("a[class]");
      const submenuName = link
        ? link.getAttribute("class").replace("is-active", "").trim()
        : false;
      const submenu = submenuName
        ? header.querySelector("#" + submenuName)
        : false;

      const currentParentItem = megamenu.querySelector(".--open");
      const currentLink = currentParentItem
        ? currentParentItem.querySelector("a[class]")
        : false;
      const currentSubmenuName = currentLink
        ? currentLink.getAttribute("class").replace("is-active", "").trim()
        : false;
      const currentSubmenu = currentSubmenuName
        ? header.querySelector("#" + currentSubmenuName)
        : false;

      if (submenu) {
        if (currentSubmenu) {
          currentParentItem.classList.remove("--open");
          currentSubmenu.classList.remove("--open");
          if (currentSubmenu === submenu) {
            header.classList.remove("--open");
          } else {
            parentItem.classList.add("--open");
            submenu.classList.add("--open");
            header.classList.add("--open");
          }
        } else {
          parentItem.classList.add("--open");
          submenu.classList.add("--open");
          header.classList.add("--open");
        }
      }
    }
  }
});

header.addEventListener("mouseover", (e) => {
  if (isDesktop) {
    // submenu corporate m-submenu-image
    if (e.target.matches(".m-submenu-image > li:not(.--open) > a")) {
      console.log(e.target);
      const opens = header.querySelectorAll(".m-submenu-image > li.--open");
      if (opens.length > 0)
        for (const open of opens) open.classList.remove("--open");
      e.target.parentElement.classList.add("--open");
    }

    // submenu products
    if (e.target.matches(".m-submenu-level3 > li:not(.--open) > a")) {
      const opens = header.querySelectorAll(".m-submenu-level3 > li.--open");
      if (opens.length > 0)
        for (const open of opens) open.classList.remove("--open");
      e.target.parentElement.classList.add("--open");
    }
  }
});
